interface SectionHeadingProps {
  label: string
  title: React.ReactNode
  description?: React.ReactNode
  meta?: string
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  label,
  title,
  description,
  meta,
}) => {
  return (
    <div className="mb-14 max-w-3xl" data-reveal>
      <div className="flex items-center gap-3 mb-4">
        <p className="section-label">{label}</p>
        {meta && (
          <span className="hidden sm:inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-400 dark:text-neutral-500">
            <span className="w-1 h-1 rounded-full bg-primary-500/60" />
            {meta}
          </span>
        )}
      </div>
      <h2 className="font-display text-display-md font-semibold tracking-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-neutral-600 dark:text-neutral-400 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  )
}

export default SectionHeading